export enum EStatusType {
  OPPORTUNITY = 'OPPORTUNITY',
  CONTRACT = 'CONTRACT',
  WORK_ORDER = 'WORK_ORDER',
}
